// Radiopicker switch
$('.btn-switch-wp .label').on('click', function() {
  $(this).prev().find('.checkbox-toggle').trigger('click');
});


$('#back-link-btn').on('click', function() {
    history.back();
});
